import React from 'react';
import Footer from './../components/Footer';
import Layout from './../components/layout';
import Container from './../components/Container';
import Row from './../components/Row';
import HelmetHeader from './../components/HelmetHeader';
import ReactPlayer from 'react-player';

const PodcastTag = (props) => (
	<li>
		<a href="/#">{`${props.name}, `}</a>
	</li>
);

class PodcastPost extends React.PureComponent {
	render() {
		const props = this.props;
		const podcastTitle = props.podcastTitle;
		const podcastSrc = props.podcastSrc;
		const tags = props.tags;
		const date = props.podcastDate;
		const description = props.podcastDescription;
		return (
			<div className="blog-post">
				<span className="date-comments">{date}</span>
				<h2>{podcastTitle}</h2>
				<Row>
					<div className="col-md-7">
						<ReactPlayer
							url={podcastSrc}
							id={podcastSrc}
						/>
					</div>
					<div className="col-md-5">
						<div dangerouslySetInnerHTML={{ __html: description }} />
						<ul className="post-tags">
							{tags.map((tag, index) => <PodcastTag key={index} name={tag.name} />)}
						</ul>
					</div>
					{/* <div className="col-md-12">
						<ul className="post-tags">
							{tags.map((tag, index) => <PodcastTag key={index} name={tag.name} />)}
						</ul>
					</div> */}
				</Row>
			</div>
		);
	};
}

const pageKeywords = [
	'Berlin Robotics Podcast',
	'Robotic Podcast',
	'Podcast',
	'Automation',
	'Robotik',
	'Autonome Logistik',
	'InSystems Automation',
	'Automating the warehouse',
	'autonomous robotics'
];

// https://www.therobotreport.com/5-robotics-development-tips/
const podcastArray = [{
	podcastTitle: "Pepper: mehr als nur automatisieren",
	podcastDate: new Date("January 23, 2019").toUTCString(),
	tags: [{ id: "1", name: "Robotics" }, { id: "21", name: "Telepresence" }, { id: "3", name: "Service" }],
	podcastSrc: "https://soundcloud.com/berlin-robotics/pepper-mehr-als-nur-automatisieren-humanizing-technologies-gmbh"
},
{
	podcastTitle: "Wer sind InSystems und wohin geht die Reise",
	podcastDate: new Date("October 30, 2018").toUTCString(),
	tags: [{ id: "1", name: "Robotics" }, { id: "3", name: "Service" }, { id: "18", name: "Intra Logistik" }],
	podcastSrc: "https://soundcloud.com/berlin-robotics/wer-sind-insystems-und-wohin-geht-die-reise"
},{
	podcastTitle: "Das Beratungsgeschäft in der Robotik",
	podcastDate: new Date("October 24, 2018").toUTCString(),
	podcastSrc: "https://soundcloud.com/berlin-robotics/das-beratungsgeschaft-in-der-robotik",
	tags: [{ id: "1", name: "Robotics" }, { id: "2", name: "Cloud" }, { id: "3", name: "Service" }, { id: "14", name: "Beratung" }],
	podcastDescription: "In diesem Podcast unterhalte ich mich mit Tom und Jozsef Weisz über deren Beratungsunternehmen und über Fahrerlose Transportsysteme (FTS) der neuen Generation. Wie sich Firmen aufstellen sollten und was die ersten Schritte der FTS integration beinhalten."
},{
	podcastTitle: "Eine Reise durch die Industrie- und Servicerobotik mit Junior Professor Jens Lambrecht",
	podcastDate: new Date("September 12, 2018").toUTCString(),
	podcastSrc: "https://soundcloud.com/berlin-robotics/eine-reise-durch-die-industrie-und-servicerobotik-mit-junior-professor-jens-lambrecht",
	tags: [{ id: "1", name: "Robotics" }, { id: "2", name: "Cloud" }, { id: "3", name: "Service" }],
	podcastDescription: "In diesem Berlin Robotics Podcast soll es um die Industrie- und Servicerobotik gehen. Junior Professor Jens Lambrecht wird uns etwas zu sich und seinen Erfahrungen erzählen und dabei auf die derzeitigen Herausforderungen eingehen."
}, {
	podcastTitle: 'Die Gründung von Gestalt Robotics GmbH mit Thomas Staufenbiel',
	podcastDate: new Date("August 15, 2018").toUTCString(),
	podcastSrc: "https://soundcloud.com/berlin-robotics/die-grundung-einer-robotic-gmbh-in-berlin",
	tags: [{ id: "1", name: "Robotics" }, { id: "2", name: "Business" }],
	podcastDescription: "Im Gespräch mit Thomas Staufenbiel (Co-Founder, Managing Director)über die Vor - und Nachteile beim gründen einer Robotiks Firma in Berlin und was man sich darunter vorstellen muss. Thomas spricht über Fehler und Learnings die man unterwegs macht."
}];

const PodcastPage = (props) => (
	<Layout>
		<HelmetHeader data={{
			title: 'Podcast',
			meta: [
				{ name: 'description', content: 'Berlin Robotics Podcast currently on soundcloud' },
				{ name: 'keywords', content: pageKeywords.join(',') },
			],
		}} />
		{/* <!-- blog-section ================================================== --> */}
		<section className="blog-section">
			<Container>
				<div className="title-section">
					<Row>
						<div className="col-lg-12">
							<span>Latest</span>
							<h1>Robotics Podcast</h1>
						</div>
						{/* <div className="col-lg-8">
							<a href="/#"><img src="https://s3.eu-central-1.amazonaws.com/berlin-robotics/upload/blog/add.jpg" alt="" /></a>
						</div> */}
					</Row>
				</div>
				<Row>
					<div className="col">
						<div className="blog-box">
							{podcastArray.map(podcast => <PodcastPost key={podcast.podcastSrc} {...podcast} />)}
						</div>
					</div>
				</Row>
			</Container>
		</section>
		{/* <!-- End blog section --> */}
		<Footer />
	</Layout>
);

export default PodcastPage;